import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import { saveUserData } from "../services/databaseService";
import "./InsuranceForm.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown,} from '@fortawesome/free-solid-svg-icons';
// import { db } from '../services/firebaseConfig';
// import { collection, doc,  setDoc, serverTimestamp } from 'firebase/firestore';
import { sendSms } from "../services/sendSms";
import { Helmet } from "react-helmet";


<Helmet>
  <title>Your Insurance Quote | Instant Coverage | Kora Insurance</title>
  <meta name="description" content="Fill out our form to get a fast, secure insurance quote. Purchase your plan online in minutes." />
  <meta name="keywords" content="Insurance Ghana, Family Insurance, Affordable Cover, Kora Insurance" />
  <meta name="robots" content="index, follow" />
  <link rel="canonical" href="https://korame.com.gh"/>
  {/* Open Graph tags */}
  <meta property="og:title" content="Best Online Insurance Platform" />
  <meta property="og:description" content="Compare and buy insurance plans with ease." />
  <meta property="og:url" content="https://korame.com.gh/" />
  <meta property="og:type" content="website" />
</Helmet>

const countryCallCodes = [
  { name: "Afghanistan", code: "+93" },
  { name: "Albania", code: "+355" },
  { name: "Algeria", code: "+213" },
  { name: "Andorra", code: "+376" },
  { name: "Angola", code: "+244" },
  { name: "Argentina", code: "+54" },
  { name: "Armenia", code: "+374" },
  { name: "Australia", code: "+61" },
  { name: "Austria", code: "+43" },
  { name: "Azerbaijan", code: "+994" },
  { name: "Bahamas", code: "+1-242" },
  { name: "Bahrain", code: "+973" },
  { name: "Bangladesh", code: "+880" },
  { name: "Barbados", code: "+1-246" },
  { name: "Belarus", code: "+375" },
  { name: "Belgium", code: "+32" },
  { name: "Belize", code: "+501" },
  { name: "Benin", code: "+229" },
  { name: "Bhutan", code: "+975" },
  { name: "Bolivia", code: "+591" },
  { name: "Bosnia and Herzegovina", code: "+387" },
  { name: "Botswana", code: "+267" },
  { name: "Brazil", code: "+55" },
  { name: "Brunei", code: "+673" },
  { name: "Bulgaria", code: "+359" },
  { name: "Burkina Faso", code: "+226" },
  { name: "Burundi", code: "+257" },
  { name: "Cambodia", code: "+855" },
  { name: "Cameroon", code: "+237" },
  { name: "Canada", code: "+1" },
  { name: "Cape Verde", code: "+238" },
  { name: "Central African Republic", code: "+236" },
  { name: "Chad", code: "+235" },
  { name: "Chile", code: "+56" },
  { name: "China", code: "+86" },
  { name: "Colombia", code: "+57" },
  { name: "Comoros", code: "+269" },
  { name: "Congo (Brazzaville)", code: "+242" },
  { name: "Congo (Kinshasa)", code: "+243" },
  { name: "Costa Rica", code: "+506" },
  { name: "Croatia", code: "+385" },
  { name: "Cuba", code: "+53" },
  { name: "Cyprus", code: "+357" },
  { name: "Czech Republic", code: "+420" },
  { name: "Denmark", code: "+45" },
  { name: "Djibouti", code: "+253" },
  { name: "Dominica", code: "+1-767" },
  { name: "Dominican Republic", code: "+1-809" },
  { name: "Ecuador", code: "+593" },
  { name: "Egypt", code: "+20" },
  { name: "El Salvador", code: "+503" },
  { name: "Equatorial Guinea", code: "+240" },
  { name: "Eritrea", code: "+291" },
  { name: "Estonia", code: "+372" },
  { name: "Ethiopia", code: "+251" },
  { name: "Fiji", code: "+679" },
  { name: "Finland", code: "+358" },
  { name: "France", code: "+33" },
  { name: "Gabon", code: "+241" },
  { name: "Gambia", code: "+220" },
  { name: "Georgia", code: "+995" },
  { name: "Germany", code: "+49" },
  { name: "Ghana", code: "+233" },
  { name: "Greece", code: "+30" },
  { name: "Grenada", code: "+1-473" },
  { name: "Guatemala", code: "+502" },
  { name: "Guinea", code: "+224" },
  { name: "Guinea-Bissau", code: "+245" },
  { name: "Guyana", code: "+592" },
  { name: "Haiti", code: "+509" },
  { name: "Honduras", code: "+504" },
  { name: "Hungary", code: "+36" },
  { name: "Iceland", code: "+354" },
  { name: "India", code: "+91" },
  { name: "Indonesia", code: "+62" },
  { name: "Iran", code: "+98" },
  { name: "Iraq", code: "+964" },
  { name: "Ireland", code: "+353" },
  { name: "Israel", code: "+972" },
  { name: "Italy", code: "+39" },
  { name: "Jamaica", code: "+1-876" },
  { name: "Japan", code: "+81" },
  { name: "Jordan", code: "+962" },
  { name: "Kazakhstan", code: "+7" },
  { name: "Kenya", code: "+254" },
  { name: "Kiribati", code: "+686" },
  { name: "North Korea", code: "+850" },
  { name: "South Korea", code: "+82" },
  { name: "Kuwait", code: "+965" },
  { name: "Kyrgyzstan", code: "+996" },
  { name: "Laos", code: "+856" },
  { name: "Latvia", code: "+371" },
  { name: "Lebanon", code: "+961" },
  { name: "Lesotho", code: "+266" },
  { name: "Liberia", code: "+231" },
  { name: "Libya", code: "+218" },
  { name: "Liechtenstein", code: "+423" },
  { name: "Lithuania", code: "+370" },
  { name: "Luxembourg", code: "+352" },
  { name: "Madagascar", code: "+261" },
  { name: "Malawi", code: "+265" },
  { name: "Malaysia", code: "+60" },
  { name: "Maldives", code: "+960" },
  { name: "Mali", code: "+223" },
  { name: "Malta", code: "+356" },
  { name: "Marshall Islands", code: "+692" },
  { name: "Mauritania", code: "+222" },
  { name: "Mauritius", code: "+230" },
  { name: "Mexico", code: "+52" },
  { name: "Micronesia", code: "+691" },
  { name: "Moldova", code: "+373" },
  { name: "Monaco", code: "+377" },
  { name: "Mongolia", code: "+976" },
  { name: "Montenegro", code: "+382" },
  { name: "Morocco", code: "+212" },
  { name: "Mozambique", code: "+258" },
  { name: "Myanmar", code: "+95" },
  { name: "Namibia", code: "+264" },
  { name: "Nauru", code: "+674" },
  { name: "Nepal", code: "+977" },
  { name: "Netherlands", code: "+31" },
  { name: "New Zealand", code: "+64" },
  { name: "Nicaragua", code: "+505" },
  { name: "Niger", code: "+227" },
  { name: "Nigeria", code: "+234" },
  { name: "Norway", code: "+47" },
  { name: "Oman", code: "+968" },
  { name: "Pakistan", code: "+92" },
  { name: "Palau", code: "+680" },
  { name: "Panama", code: "+507" },
  { name: "Papua New Guinea", code: "+675" },
  { name: "Paraguay", code: "+595" },
  { name: "Peru", code: "+51" },
  { name: "Philippines", code: "+63" },
  { name: "Poland", code: "+48" },
  { name: "Portugal", code: "+351" },
  { name: "Qatar", code: "+974" },
  { name: "Romania", code: "+40" },
  { name: "Russia", code: "+7" },
  { name: "Rwanda", code: "+250" },
  { name: "Saint Kitts and Nevis", code: "+1-869" },
  { name: "Saint Lucia", code: "+1-758" },
  { name: "Saint Vincent and the Grenadines", code: "+1-784" },
  { name: "Samoa", code: "+685" },
  { name: "San Marino", code: "+378" },
  { name: "Sao Tome and Principe", code: "+239" },
  { name: "Saudi Arabia", code: "+966" },
  { name: "Senegal", code: "+221" },
  { name: "Serbia", code: "+381" },
  { name: "Seychelles", code: "+248" },
  { name: "Sierra Leone", code: "+232" },
  { name: "Singapore", code: "+65" },
  { name: "Slovakia", code: "+421" },
  { name: "Slovenia", code: "+386" },
  { name: "Solomon Islands", code: "+677" },
  { name: "Somalia", code: "+252" },
  { name: "South Africa", code: "+27" },
  { name: "South Sudan", code: "+211" },
  { name: "Spain", code: "+34" },
  { name: "Sri Lanka", code: "+94" },
  { name: "Sudan", code: "+249" },
  { name: "Suriname", code: "+597" },
  { name: "Swaziland", code: "+268" },
  { name: "Sweden", code: "+46" },
  { name: "Switzerland", code: "+41" },
  { name: "Syria", code: "+963" },
  { name: "Taiwan", code: "+886" },
  { name: "Tajikistan", code: "+992" },
  { name: "Tanzania", code: "+255" },
  { name: "Thailand", code: "+66" },
  { name: "Timor-Leste", code: "+670" },
  { name: "Togo", code: "+228" },
  { name: "Tonga", code: "+676" },
  { name: "Trinidad and Tobago", code: "+1-868" },
  { name: "Tunisia", code: "+216" },
  { name: "Turkey", code: "+90" },
  { name: "Turkmenistan", code: "+993" },
  { name: "Tuvalu", code: "+688" },
  { name: "Uganda", code: "+256" },
  { name: "Ukraine", code: "+380" },
  { name: "United Arab Emirates", code: "+971" },
  { name: "United Kingdom", code: "+44" },
  { name: "United States", code: "+1" },
  { name: "Uruguay", code: "+598" },
  { name: "Uzbekistan", code: "+998" },
  { name: "Vanuatu", code: "+678" },
  { name: "Vatican City", code: "+379" },
  { name: "Venezuela", code: "+58" },
  { name: "Vietnam", code: "+84" },
  { name: "Yemen", code: "+967" },
  { name: "Zambia", code: "+260" },
  { name: "Zimbabwe", code: "+263" }
];

const ghanaRegions = [
  "Ahafo", "Ashanti", "Bono", "Bono East", "Central",
  "Eastern", "Greater Accra", "Northern", "North East",
  "Oti", "Savannah", "Upper East", "Upper West", "Volta", "Western", "Western North"
];



/**
 * Inline subcomponent for Paystack fields
 * This uses data-paystack="..." for card number, expiry, CVV, etc. if channels=["card"].
 * For MoMo, we might display a phone field or let Paystack prompt automatically.
 */
function PaystackInlineFields({ amountInPesewas, email, channels, onPaymentSuccess, onPaymentError }) {

  const [message, setMessage] = useState("");

  //validate email
  const validateEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/; // Basic email regex
    return regex.test(email);
  };

  // This handleSubmit triggers the Paystack flow with the user's typed card/MoMo fields
  const handleSubmit = (e) => {
    e.preventDefault();

    // Validate email
    if (!email || !validateEmail(email)) {
      setMessage("Please enter a valid email address.");
      return;
    }

    if (!window.PaystackPop) {
      onPaymentError?.("Paystack script not loaded");
      return;
    }

    const publicKey = process.env.REACT_APP_PAYSTACK_PUBLIC_KEY;
    const paystack = new window.PaystackPop(); // from the v2 script
    // console.log("🔑 Paystack Config:", {
    //   key: publicKey,
    //   email,
    //   amount: amountInPesewas,
    //   currency: "GHS",
    //   channels
    // });
    paystack.newTransaction({
      key: publicKey,
      amount: amountInPesewas, // GH₵ => pesewas
      email,
      currency: "GHS",
      channels, // e.g. ["card"] or ["mobile_money"]

      // The newTransaction() call automatically reads the <input data-paystack="..."> values
      // if channels includes 'card' for these fields:
      onSuccess: (transaction) => {
        onPaymentSuccess?.(transaction);
      },
      onCancel: () => {
        onPaymentError?.("User canceled payment");
      },
    });
  };
  console.log(process.env.REACT_APP_PAYSTACK_PUBLIC_KEY);


  return (
    <form onSubmit={handleSubmit} className="paystack-inline-form">
      {channels.includes("card") && (
        <>
          <h2>Credit Card Details</h2>
          <div className="form-group">
            <label>Card Number</label>
            <input
              type="text"
              data-paystack="number"
              placeholder="xxxx xxxx xxxx xxxx"
              required
            />
          </div>
          <div className="form-group">
            <label>Expiry Date (MM/YY)</label>
            <input
              type="text"
              data-paystack="expiry"
              placeholder="MM/YY"
              required
            />
          </div>
          <div className="form-group">
            <label>CVV</label>
            <input
              type="text"
              data-paystack="cvv"
              placeholder="xxx"
              required
            />
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              data-paystack="email"
              defaultValue={email}
              required
            />
          </div>
        </>
      )}

      {channels.includes("mobile_money") && (
        <>
          <h2>Mobile Money Payment</h2>
          {/* 
            Optionally show a phone number field. 
            Paystack's MoMo flow may also prompt automatically. 
            If you want the user to supply phone here, do:
           */}
          <div className="form-group">
            <label>Mobile Money Number</label>
            <input
              type="tel"
              data-paystack="phone"
              placeholder="e.g. 233XX..."
            />
          </div>
        </>
      )}

      <button type="submit" className="paystack-submit-button select-button">
        Pay Now
      </button>

      {message && <p className="error message">{message}</p>}
    </form>
  );
}

/* -------------------- The rest is the InsuranceForm code ------------------ */

const coverDetails = {
  bronze: {
    title: "Bronze Plan",
    price: "Gh₵ 1,500",
    features: [
      "Disability (Accident): Gh₵ 3,000",
      "Hospitalization Benefit: Gh₵ 50/day",
      "Monthly Premium: Gh₵ 4.32",
      "Annual Premium: Gh₵ 51.84",
    ],
    annualPremium: 51.84,
  },
  silver: {
    title: "Silver Plan",
    price: "Gh₵ 2,500",
    features: [
      "Disability (Accident): Gh₵ 5,000",
      "Hospitalization Benefit: Gh₵ 100/day",
      "Monthly Premium: Gh₵ 8.07",
      "Annual Premium: Gh₵ 96.79",
    ],
    annualPremium: 96.79,
  },
  gold: {
    title: "Gold Plan",
    price: "Gh₵ 5,000",
    features: [
      "Disability (Accident): Gh₵ 10,000",
      "Hospitalization Benefit: Gh₵ 200/day",
      "Monthly Premium: Gh₵ 16.13",
      "Annual Premium: Gh₵ 193.58",
    ],
    annualPremium: 193.58,
  },
};

const familyOptions = {
  family_option_1: [
    "Age band: 1-69yrs | Life Cover: Gh₵ 1,000 | Monthly: Gh₵ 2.63 | Annual: Gh₵ 31.58",
    "Age band: 70-74yrs | Life Cover: Gh₵ 1,000 | Monthly: Gh₵ 13.25 | Annual: Gh₵ 159.02",
    "Age band: 75-84yrs | Life Cover: Gh₵ 1,000 | Monthly: Gh₵ 24.18 | Annual: Gh₵ 290.16",
  ],
  family_option_2: [
    "Age band: 1-69yrs | Life Cover: Gh₵ 2,000 | Monthly: Gh₵ 5.26 | Annual: Gh₵ 63.15",
    "Age band: 70-74yrs | Life Cover: Gh₵ 2,000 | Monthly: Gh₵ 26.50 | Annual: Gh₵ 318.03",
    "Age band: 75-84yrs | Life Cover: Gh₵ 2,000 | Monthly: Gh₵ 48.36 | Annual: Gh₵ 580.32",
  ],
};

const GHACardMask = "GHA-XXXXXXXXX-X";
const ageGroups = ["1-69 years", "70-74 years", "75-84 years"];

//Relationship max constraints
const RELATIONSHIP_MAX = {
  Spouse: 1,
  Parent: 2,
  Inlaw: 1,
  Others: 2,
};


function parseFamilyOptionLine(line) {
  if (!line) return { monthlyVal: 0, annualVal: 0 };
  const parts = line.split("|").map((p) => p.trim());
  let monthlyVal = 0;
  let annualVal = 0;
  parts.forEach((part) => {
    const lower = part.toLowerCase();
    if (lower.includes("monthly")) {
      const val = part.split(":")[1].trim().replace("Gh₵", "").trim();
      monthlyVal = parseFloat(val) || 0;
    } else if (lower.includes("annual")) {
      const val = part.split(":")[1].trim().replace("Gh₵", "").trim();
      annualVal = parseFloat(val) || 0;
    }
  });
  return { monthlyVal, annualVal };
}

function parseCoverMainPremiums(features) {
  if (!Array.isArray(features)) return { mainMonthly: 0, mainAnnual: 0 };
  let mainMonthly = 0;
  let mainAnnual = 0;
  features.forEach((f) => {
    const lower = f.toLowerCase();
    if (lower.includes("monthly premium")) {
      const val = f.split(":")[1].trim().replace("Gh₵", "").trim();
      mainMonthly = parseFloat(val) || 0;
    } else if (lower.includes("annual premium")) {
      const val = f.split(":")[1].trim().replace("Gh₵", "").trim();
      mainAnnual = parseFloat(val) || 0;
    }
  });
  return { mainMonthly, mainAnnual };
}

/* Helper to count usage of a relationship in an array*/
function relationshipUsage(beneficiaries, rel) {
  return beneficiaries.filter((b) => b.relationship === rel).length;
}


function InsuranceForm({ agentId: propAgentId, isModal = false }) {
  const navigate = useNavigate();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  // e.g. "?plan=silver&tier=tier1&ageBandIndex=1"
  const plan = searchParams.get("plan");
  const tier = searchParams.get("tier");
  const ageBandIndexParam = searchParams.get("ageBandIndex");
  const relationship = searchParams.get("relationship");
  const agentId = propAgentId || searchParams.get("agentId");

  console.log("Current Agent Id:", agentId);


  let initialCoverOption = "";
  if (plan === "bronze") initialCoverOption = "bronze";
  else if (plan === "silver") initialCoverOption = "silver";
  else if (plan === "gold") initialCoverOption = "gold";

  let initialCoverDetailsOption = "";
  if (tier === "tier1") initialCoverDetailsOption = "family_option_1";
  else if (tier === "tier2") initialCoverDetailsOption = "family_option_2";

  let initialAgeIndex = 0;
  if (!isNaN(ageBandIndexParam)) {
    const idx = parseInt(ageBandIndexParam, 10);
    if (idx >= 0 && idx <= 2) initialAgeIndex = idx;
  }

  let initialRelationship = "";
  if (relationship) initialRelationship = relationship;

  const toggleExpand = (index) => {
    setExpanded((prev) => ({ ...prev, [index]: !prev[index] }));
  };



  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phoneNumber: "",
    dateOfBirth: "",
    location: "",
    region: "",
    payeeGhanaCardNumber: "",
    coverOption: initialCoverOption || "",
    paymentMethod: "credit_card",
    coverDetailsOption: "",
    ageGroup: "",
    nextofkin: "",
    nextofkinGhanaCard: "",
    countryCode: "+233",
    agentId: agentId || "",
  });

  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      agentId: propAgentId || searchParams.get("agentId") || "", // Ensure agentId is assigned correctly
    }));
  }, [propAgentId]);  




  // ================== NEW: Beneficiaries Array ==================
  // Each element will have: { relationship: "", name: "", phone: "", ghanaCard: "" }
  const [beneficiaries, setBeneficiaries] = useState([{ relationship: initialRelationship || "", firstName: "", lastName: "", phone: "", ghanaCard: "", coverDetailsOption: initialCoverDetailsOption || "", ageGroup: ageGroups[initialAgeIndex] || "" }]);
  const [expanded, setExpanded] = useState({});



  // Ghana card typed counts for the payee only
  const [payeeTypedCount, setPayeeTypedCount] = useState(0);
  //  but for simplicity, we can skip that typed logic for them, or replicate it if you want.)

  const [focusedInput, setFocusedInput] = useState(null);
  const [message, setMessage] = useState("");
  const [featuresExpanded, setFeaturesExpanded] = useState(false);
  const [countryCode, setCountryCode] = useState("+233");
  const [selectedCountry, setSelectedCountry] = useState("Ghana"); // Default to Ghana

  const [beneficiaryTypedCount, setBeneficiaryTypedCount] = useState(0);


  // Refs for Ghana card inputs
  const payeeRef = useRef(null);
  const beneficiaryRef = useRef(null);

  // ================= Premium Calculation ================
  const calcPremiums = () => {
    console.log("Running calcPremiums...");
    console.log("Selected Cover Option:", formData.coverOption);

    const selectedCover = coverDetails[formData.coverOption];
    if (!selectedCover || !selectedCover.features) {
      console.warn("No valid cover option selected.");
      return { monthly: 0, annual: 0 };
    }

    let { mainMonthly, mainAnnual } = parseCoverMainPremiums(selectedCover.features);
    console.log("Base Plan Premiums:", { mainMonthly, mainAnnual });

    let additionalMonthly = 0;
    let additionalAnnual = 0;

    beneficiaries.forEach((b, index) => {
      console.log(`Processing Beneficiary ${index + 1}:`, b);

      if (!b.coverDetailsOption) {
        console.warn(`Skipping Beneficiary ${index + 1} - No coverDetailsOption selected.`);
        return;
      }

      if (!b.ageGroup) {
        console.warn(`Skipping Beneficiary ${index + 1} - No ageGroup selected.`);
        return;
      }

      const familyArr = familyOptions[b.coverDetailsOption]; // Use beneficiary's selected Tier
      if (!familyArr) {
        console.warn(`No family options found for ${b.coverDetailsOption}`);
        return;
      }

      let ageIndex = ageGroups.indexOf(b.ageGroup);
      if (ageIndex < 0) ageIndex = 0;

      console.log(`Beneficiary Age Group: ${b.ageGroup} -> Index: ${ageIndex}`);

      const line = familyArr[ageIndex];
      console.log(`Line for this age group: ${line}`);

      const { monthlyVal, annualVal } = parseFamilyOptionLine(line);
      console.log(`Extracted Premiums -> Monthly: ${monthlyVal}, Annual: ${annualVal}`);

      additionalMonthly += monthlyVal;
      additionalAnnual += annualVal;
    });

    console.log("Total Additional Premiums:", { additionalMonthly, additionalAnnual });

    return {
      monthly: mainMonthly + additionalMonthly,
      annual: mainAnnual + additionalAnnual,
    };
  };


  const [monthly, setMonthly] = useState(0);
  const [annual, setAnnual] = useState(0);
  const [amountInPesewas, setAmountInPesewas] = useState(0);

  useEffect(() => {
    console.log("CoverOption:", formData.coverOption);
    console.log("CoverDetailsOption:", beneficiaries.coverDetailsOption);
    console.log("Beneficiaries:", beneficiaries);
    const { monthly, annual } = calcPremiums();
    console.log("UpdatedPremiums:", { monthly, annual });
    setMonthly(monthly);
    setAnnual(annual);
    setAmountInPesewas(Math.round(annual * 100));
  }, [formData.coverOption, beneficiaries]);


  // ============ Handlers for normal input ===============
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handlePhoneNumberChange = (e, fieldName) => {
    let val = e.target.value.replace(/\D/g, "");
    if (val.startsWith("0")) {
      val = val.substring(1);
    }
    setFormData((prev) => ({ ...prev, [fieldName]: val }));
  };

  // Insert char at index
  const insertCharAt = (str, index, char) => {
    return str.slice(0, index) + char + str.slice(index + 1);
  };

  // GHANA CARD
  const handleGhanaCardFocus = (e, fieldName, index = null) => {
    if (fieldName === "payeeGhanaCardNumber") {
      setFormData((prev) => ({
        ...prev,
        [fieldName]: prev[fieldName] || "GHA-XXXXXXXXX-X",
      }));
    } else if (index !== null) {
      setBeneficiaries((prev) => {
        const updated = [...prev];
        if (!updated[index].ghanaCardNumber) {
          updated[index].ghanaCardNumber = "GHA-XXXXXXXXX-X";
        }
        return updated;
      });
    }
  };


  const handleGhanaCardBlur = (e, fieldName, index = null) => {
    if (fieldName === "payeeGhanaCardNumber") {
      setFormData((prev) => ({
        ...prev,
        [fieldName]: prev[fieldName] === "GHA-XXXXXXXXX-X" ? "" : prev[fieldName],
      }));
    } else if (index !== null) {
      setBeneficiaries((prev) => {
        const updated = [...prev];
        if (updated[index].ghanaCardNumber === "GHA-XXXXXXXXX-X") {
          updated[index].ghanaCardNumber = "";
        }
        return updated;
      });
    }
  };


  const handleGhanaCardKeyDown = (e, fieldName, typedCount, typedCountSetter) => {
    if (e.key === "Backspace" && typedCount > 0) {
      e.preventDefault();
      let newVal = formData[fieldName];
      let removeIndex = typedCount === 10 ? 14 : 4 + (typedCount - 1);
      newVal = insertCharAt(newVal, removeIndex, "X");
      setFormData((prev) => ({ ...prev, [fieldName]: newVal }));
      typedCountSetter(typedCount - 1);

      setTimeout(() => {
        const input =
          fieldName === "payeeGhanaCardNumber" ? payeeRef.current : beneficiaryRef.current;
        if (input && input.setSelectionRange) {
          let cursorPos = typedCount === 10 ? 14 : 4 + (typedCount - 1);
          if (cursorPos < 4) cursorPos = 4;
          input.setSelectionRange(cursorPos, cursorPos);
        }
      }, 0);
    }
  };

  const handleGhanaCardChange = (e, fieldName, typedCount, typedCountSetter, index = null) => {
    const input = e.target;
    let newVal = input.value.toUpperCase();
    const cursorPosition = input.selectionStart;  // Get cursor position before changes

    if (!newVal.startsWith("GHA-")) {
      setTimeout(() => {
        if (input.setSelectionRange) {
          input.setSelectionRange(4, 4);
        }
      }, 0);

      if (index === null) {
        setFormData((prev) => ({ ...prev, [fieldName]: "GHA-XXXXXXXXX-X" }));
      } else {
        setBeneficiaries((prev) => {
          const updated = [...prev];
          updated[index] = { ...updated[index], ghanaCardNumber: "GHA-XXXXXXXXX-X" };
          return updated;
        });
      }
      return;
    }

    const strippedVal = newVal.replace(/[^A-Z0-9]/g, "");
    let typedCharacters = strippedVal.length - 3;
    if (typedCharacters < 0) typedCharacters = 0;

    let formattedValue = "GHA-XXXXXXXXX-X";
    const inputChars = newVal.slice(4).replace(/[^A-Z0-9]/g, "");

    for (let i = 0; i < typedCharacters && i < 10; i++) {
      let replaceIndex = i < 9 ? 4 + i : 14;
      formattedValue = formattedValue.substring(0, replaceIndex) + inputChars[i] + formattedValue.substring(replaceIndex + 1);
    }

    if (index === null) {
      setFormData((prev) => ({ ...prev, [fieldName]: formattedValue }));
    } else {
      setBeneficiaries((prev) => {
        const updated = [...prev];
        updated[index] = { ...updated[index], ghanaCardNumber: formattedValue };
        return updated;
      });
    }

    // Only force cursor position if we're at the start or end
    setTimeout(() => {
      if (input.setSelectionRange) {
        let newCursorPosition = cursorPosition;

        // Ensure cursor doesn't move before "GHA-"
        if (newCursorPosition <= 4) {
          newCursorPosition = 4;
        }

        input.setSelectionRange(newCursorPosition, newCursorPosition);
      }
    }, 0);
  };


  //Handle countrycode change 
  const handleCountryCodeChange = (e) => {
    setCountryCode(e.target.value);
  };

  const handleCountryChange = (e) => {
    const selected = e.target.value;
    setFormData((prev) => ({ ...prev, location: selected }));
    setSelectedCountry(selected);  // Dynamically update country selection
  };


  const nationalNumberMaxLength = 15 - countryCode.replace("+", "").length;

  const handlePaystackSuccess = async (transaction) => {
    console.log("Payment success:", transaction);

    try {
      // Save user data, including agentId if present
      const userData = {
        ...formData,
        annualPremium: annual,
        submittedAt: new Date().toISOString(),
        paystackRef: transaction.reference,
        beneficiaries: beneficiaries,
        agentId: agentId,
      };

      if (agentId) {
        userData.agentId = agentId; // Attach agent ID to user's data
      }

      const docId = await saveUserData(userData);

      // // If an agent registered this user, update their registration count
      // if (agentId) {
      //   const agentRef = doc(db, "agents", agentId, "registrations", docId);
      //   await setDoc(agentRef, {
      //     clientId: docId,
      //     timestamp: serverTimestamp(),
      //     ...userData,

      //   });
      // }

      setMessage(`Your payment has been processed successfully. Ref ID: ${docId}`);
      await sendSms({
        to: `233${formData.phoneNumber}`, // Ensure it’s in international format
        message: `Hi ${formData.firstName}, you have successfully subscribed to the ${formData.coverOption} plan under Kora insurance. Your monthly premium is GHS${monthly.toFixed(2)}.Policy Reference: ${transaction.reference}. Thank you for choosing Kora!`,
      });

      navigate("/confirmation", {
        state: {
          policyNumber: docId,
          fullName: `${formData.firstName} ${formData.lastName}`,
          coverOption: formData.coverOption,
          tier: formData.coverDetailsOption,
          annualAmount: annual,
          monthlyAmount: monthly,
          phoneNumber: formData.phoneNumber,
          email: formData.email,
          paymentReference: transaction.reference,
          dateOfPayment: new Date().toISOString(),
          beneficiaries: beneficiaries,
        },
      });
    } catch (err) {
      console.error("Post-payment error:", err);
      setMessage("Payment succeeded but error saving or sending SMS.");
    }
  };

  // Called when payment is canceled or if an error occurs
  const handlePaystackError = (errMsg) => {
    console.warn("Payment was canceled or errored:", errMsg);
    setMessage(errMsg || "Payment canceled.");
  };

  // Toggler for plan features
  const toggleFeaturesExpanded = () => {
    setFeaturesExpanded(!featuresExpanded);
  };

  // ============ BENEFICIARY LOGIC =============
  const addBeneficiary = () => {
    const newBeneficiary = {
      name: "",
      ageGroup: "",
      phoneNumber: "",
      relationship: "",
      coverDetailsOption: formData.coverDetailsOption,
    };
    setBeneficiaries([...beneficiaries, newBeneficiary]);


    // Reset all expanded states to false and set only the new one to true
    setExpanded({
      [beneficiaries.length]: true // Index of the new beneficiary
    });
  };

  // Change a field in an existing beneficiary
  const handleBeneficiaryField = (index, field, value) => {
    setBeneficiaries((prev) => {
      const updated = [...prev];
      updated[index] = { ...updated[index], [field]: value };
      return updated;
    });
  };

  // Remove a beneficiary
  const removeBeneficiary = (index) => {
    setBeneficiaries((prev) => prev.filter((_, i) => i !== index));
  };

  // Dynamically disable relationships that reached max usage
  const renderRelationshipOptions = (currentRel) => {
    return (
      <>
        <option value="">Select Relationship</option>
        {Object.entries(RELATIONSHIP_MAX).map(([rel, maxAllowed]) => {
          let usedCount = relationshipUsage(beneficiaries, rel);
          // If this row was already using rel, reduce usage by 1
          if (currentRel === rel) usedCount -= 1;

          const isDisabled = usedCount >= maxAllowed;
          return (
            <option key={rel} value={rel} disabled={isDisabled}>
              {rel} (maximum: {maxAllowed})
            </option>
          );
        })}
      </>
    );
  };



  const chosenPlan = formData.coverOption
    ? coverDetails[formData.coverOption]
    : null;
  const chosenPlanFeatures = chosenPlan ? chosenPlan.features : [];

  return (
    <div className="insurance-form-page">
      <Header />
      <div className={"form-content " + (formData.coverOption && isModal ? "slightly-shifted" : "")}>
        <div className="form-container">
          <div className="form-card">
            <h1>Kora Insurance</h1>
            <p>Please provide the following information to set up your insurance.</p>

            <form>
              {/* FIRST NAME */}
              <div className="form-group">
                <input
                  type="text"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  placeholder=" "
                  required
                />
                <label>First Name</label>
              </div>

              {/* LAST NAME */}
              <div className="form-group">
                <input
                  type="text"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  placeholder=" "
                  required
                />
                <label>Last Name</label>
              </div>

              {/* EMAIL */}
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder=" "
                  required
                />
                <label>Email</label>
              </div>

              {/* PHONE (Dynamic country code) */}
              <div className="form-group phone-input-with-label">
                <label>Phone Number (no leading 0)</label>
                <div className="phone-input-wrapper">
                  <div>
                    {/* Country code selector*/}
                    <select
                      className="country-selector"
                      onChange={handleCountryCodeChange}
                      value={countryCode}
                    >
                      {countryCallCodes.map((country) => (
                        <option key={country.code} value={country.code}>
                          {country.name} ({country.code})
                        </option>
                      ))}
                    </select>
                  </div>
                  <input
                    type="tel"
                    name="phoneNumber"
                    value={formData.phoneNumber}
                    onChange={(e) => handlePhoneNumberChange(e, "phoneNumber")}
                    required
                    maxLength={nationalNumberMaxLength}
                    placeholder="Enter Phone Number"
                  />
                </div>
              </div>

              {/* DATE OF BIRTH */}
              <div className="form-group">
                <input
                  type="date"
                  name="dateOfBirth"
                  value={formData.dateOfBirth}
                  onChange={handleChange}
                  required
                />
                <label>Date of Birth</label>
              </div>

              {/*COUNTRY DETAILS*/}
              <div className="form-group">
                <select
                  name="location"
                  value={formData.location}
                  onChange={handleCountryChange}
                  required
                >
                  <option value="">Select Country</option>
                  {countryCallCodes.map((country) => (
                    <option key={country.code} value={country.name}>
                      {country.name}
                    </option>
                  ))}
                </select>
                <label className={formData.location ? "filled" : ""}>Country</label>
              </div>


              {/* Dynamically render Region field only if Ghana is selected */}
              {formData.location === "Ghana" && (
                <div className="form-group">
                  <select
                    name="region"
                    value={formData.region}
                    onChange={handleChange}
                    required

                    className={formData.region ? "filled" : ""}
                  >
                    <option value="" disabled>Select Region</option>
                    {ghanaRegions.map((region, index) => (
                      <option key={index} value={region}>{region}</option>
                    ))}
                  </select>
                  <label className={formData.region ? "filled" : ""}>Region</label>
                </div>
              )}

              {/* PAYEE GHANA CARD */}
              <div className="form-group">
                <input
                  ref={payeeRef}
                  type="text"
                  name="payeeGhanaCardNumber"
                  value={formData.payeeGhanaCardNumber}
                  onFocus={(e) => handleGhanaCardFocus(e, "payeeGhanaCardNumber", setPayeeTypedCount)}
                  onBlur={(e) => handleGhanaCardBlur(e, "payeeGhanaCardNumber", payeeTypedCount)}
                  onKeyDown={(e) =>
                    handleGhanaCardKeyDown(
                      e,
                      "payeeGhanaCardNumber",
                      payeeTypedCount,
                      setPayeeTypedCount
                    )
                  }
                  onChange={(e) =>
                    handleGhanaCardChange(
                      e,
                      "payeeGhanaCardNumber",
                      payeeTypedCount,
                      setPayeeTypedCount
                    )
                  }
                  placeholder=" "
                />
                <label
                  className={focusedInput === "payeeGhanaCardNumber" ? "active" : ""}
                >
                  Payee Ghana Card Number
                </label>
              </div>

              {/* COVER OPTION */}
              <div className="form-group cover-option-group">
                <select
                  name="coverOption"
                  value={formData.coverOption}
                  onChange={handleChange}
                  required
                >
                  <option value="" disabled>
                    Select Cover Option
                  </option>
                  <option value="bronze">Bronze</option>
                  <option value="silver">Silver</option>
                  <option value="gold">Gold</option>
                </select>
                <label>Your Cover Option</label>
              </div>

              {/* NEXT OF KIN */}
              <div className="form-group">
                <input
                  type="text"
                  name="nextofkin"
                  value={formData.nextofkin}
                  onChange={handleChange}
                  placeholder=" "
                  required
                />
                <label>Beneficiary/Next of kin</label>
              </div>

              {/* NEXT OF KIN GHANA CARD */}
              <div className="form-group">
                <input
                  type="text"
                  value={formData.nextofkinGhanaCard}
                  onFocus={(e) => handleGhanaCardFocus(e, "nextofkinGhanaCard")}
                  onBlur={(e) => handleGhanaCardBlur(e, "nextofkinGhanaCard")}
                  onKeyDown={(e) => handleGhanaCardKeyDown(e, "nextofkinGhanaCard", payeeTypedCount, setPayeeTypedCount)}
                  onChange={(e) => handleGhanaCardChange(e, "nextofkinGhanaCard", payeeTypedCount, setPayeeTypedCount)}
                  placeholder=" "
                  required
                />
                <label className={formData.nextofkinGhanaCard ? "filled" : ""}>Ghana Card Number</label>
              </div>

              {/* Added Lives*/}
              <div className="added-life-header">Add a Life</div>
              <div className="sub-text">You must add at least one "life" to your policy.</div>
              {beneficiaries.map((b, index) => (
                <div key={index} className={`al-beneficiary-section ${expanded[index] ? 'expanded' : ''}`}>
                  <div
                    className="al-beneficiary-header"
                    onClick={() => toggleExpand(index)}
                  >
                    <div className="beneficiary-info">
                      <span>Life {index + 1}</span>
                      {(b.firstName || b.lastName) && (
                        <span> - {[b.firstName, b.lastName].filter(Boolean).join(' ')}</span>
                      )}
                    </div>
                    <div className="beneficiary-actions">
                      <FontAwesomeIcon
                        icon={faChevronDown}
                        className={`fa-icon-toggle ${expanded[index] ? 'expanded' : ''}`}
                        style={{ width: '12px', height: '12px', cursor: 'pointer' }}
                      />
                      <button
                        className="remove-beneficiary-btn"
                        onClick={(e) => {
                          e.stopPropagation();
                          removeBeneficiary(index);
                        }}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          stroke="currentColor"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M6 18L18 6M6 6l12 12"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>

                  <div className="beneficiary-content">
                    <div className="form-group">
                      <div className="select-wrapper">
                        <label className={b.relationship ? "filled" : ""}>Relationship</label>
                        <select
                          value={b.relationship}
                          onChange={(e) => handleBeneficiaryField(index, "relationship", e.target.value)}
                          required
                        >
                          {renderRelationshipOptions(b.relationship)}
                        </select>
                      </div>
                    </div>

                    {/* FIRST NAME */}
                    <div className="form-group row-fields">
                      <div className="input-group">
                        <input
                          type="text"
                          name="firstName"
                          value={b.firstName}
                          onChange={(e) => handleBeneficiaryField(index, "firstName", e.target.value)}
                          placeholder=" "
                          required
                        />
                        <label>First Name</label>
                      </div>

                      <div className="input-group">
                        <input
                          type="text"
                          name="lastName"
                          value={b.lastName}
                          onChange={(e) => handleBeneficiaryField(index, "lastName", e.target.value)}
                          placeholder=" "
                          required
                        />
                        <label>Last Name</label>
                      </div>
                    </div>

                    <div className="form-group">
                      <input
                        type="tel"
                        value={b.phoneNumber}
                        onChange={(e) => handleBeneficiaryField(index, "phoneNumber", e.target.value)}
                        placeholder=" "
                        required
                      />
                      <label>Phone Number</label>
                    </div>

                    <div className="form-group">
                      <input
                        type="text"
                        value={b.ghanaCardNumber}
                        onFocus={(e) => handleGhanaCardFocus(e, index)}
                        onBlur={(e) => handleGhanaCardBlur(e, index)}
                        onKeyDown={(e) => handleGhanaCardKeyDown(e, index)}
                        onChange={(e) => handleGhanaCardChange(e, "ghanaCardNumber", beneficiaryTypedCount, setBeneficiaryTypedCount, index)}
                        placeholder=" "
                        required
                      />
                      <label className={b.ghanaCardNumber ? "filled" : ""}>Ghana Card Number</label>
                    </div>

                    {/* TIER */}
                    <div className="form-group cover-option-group">
                      <select
                        name="coverDetailsOption"
                        value={b.coverDetailsOption}
                        onChange={(e) => handleBeneficiaryField(index, "coverDetailsOption", e.target.value)}
                        disabled={!formData.coverOption}
                        required
                      >
                        <option value="" disabled>
                          Select Tier
                        </option>
                        <option value="family_option_1">Tier 1</option>
                        <option value="family_option_2">Tier 2</option>
                      </select>
                      <label>Cover Option Details</label>
                    </div>

                    {/* Age Group Selector */}
                    <div className="form-group">
                      <div className="select-wrapper">
                        <label className={b.ageGroup ? "filled" : ""}>Age Group</label>
                        <select
                          value={b.ageGroup}
                          onChange={(e) => handleBeneficiaryField(index, "ageGroup", e.target.value)}
                          required
                        >
                          <option value="">Select age group</option>
                          {ageGroups.map((group) => (
                            <option key={group} value={group}>
                              {group}
                            </option>
                          ))}
                        </select>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
              <button
                type="button"
                className="add-life-button"
                onClick={addBeneficiary}
              >
                Add another Life
              </button>

              {/* PAYMENT METHOD */}
              <div className="payment-section">
                <h2>Payment Method</h2>
                <div className="payment-methods">
                  <label
                    className={
                      formData.paymentMethod === "credit_card" ? "active" : ""
                    }
                  >
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="credit_card"
                      checked={formData.paymentMethod === "credit_card"}
                      onChange={handleChange}
                    />
                    <span className="icon">💳</span> Credit Card
                  </label>

                  <label
                    className={formData.paymentMethod === "momo" ? "active" : ""}
                  >
                    <input
                      type="radio"
                      name="paymentMethod"
                      value="momo"
                      checked={formData.paymentMethod === "momo"}
                      onChange={handleChange}
                    />
                    <span className="icon">📱</span> Mobile Money
                  </label>
                </div>
              </div>
            </form>
            {/* 
              Now we embed the inline Paystack fields
              - If user chooses "credit_card", show card fields
              - If "momo", show MoMo fields
            */}
            {(formData.paymentMethod === "credit_card" || formData.paymentMethod === "momo") && annual > 0 && (
              <PaystackInlineFields
                amountInPesewas={amountInPesewas}
                email={formData.email}
                channels={
                  formData.paymentMethod === "credit_card"
                    ? ["card"]
                    : ["mobile_money"]
                }
                onPaymentSuccess={handlePaystackSuccess}
                onPaymentError={handlePaystackError}
              />
            )}
            {message && <p className="message">{message}</p>}
          </div>
        </div>
      </div>
      {formData.coverOption && (
        <div className="summary-right">
          <div className="plan-summary-box">
            <div
              className="summary-header"
              style={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h2 className="summary-title" style={{ margin: 0 }}>
                Your Plan Summary
              </h2>
              <span
                style={{ fontSize: "1.2rem", fontWeight: "bold", cursor: "pointer" }}
                onClick={() => setFeaturesExpanded(!featuresExpanded)}
              >
                {featuresExpanded ? "-" : "+"}
              </span>
            </div>
            <hr style={{ margin: "10px 0" }} />

            {chosenPlan && (
              <p style={{ fontSize: "0.9rem", color: "#000", marginBottom: "5px" }}>
                <strong>Cover Option:</strong> {chosenPlan.title.replace(" Plan", "")}
              </p>
            )}

            {featuresExpanded && chosenPlan && (
              <ul style={{ listStyle: "disc", paddingLeft: "20px", marginBottom: "10px" }}>
                {chosenPlanFeatures.map((f, i) => (
                  <li key={i} style={{ fontSize: "0.9rem", marginBottom: "5px" }}>
                    {f}
                  </li>
                ))}
              </ul>
            )}

            <hr style={{ margin: "10px 0" }} />

            {/* Loop through beneficiaries and display their details */}
            {beneficiaries.length > 0 && (
              <div>
                <h3 style={{ fontSize: "1rem", marginBottom: "5px" }}>Added Lives:</h3>
                <ul style={{ paddingLeft: "20px", marginBottom: "10px" }}>
                  {beneficiaries.map((b, index) => (
                    <li key={index} style={{ fontSize: "0.9rem", marginBottom: "5px" }}>
                      <strong>{b.firstName} {b.lastName || ""}</strong><br />
                      <span> Relationship: {b.relationship || "N/A"}</span><br />
                      <span> Tier: {b.coverDetailsOption ? (b.coverDetailsOption === "family_option_1" ? "Tier 1" : "Tier 2") : "N/A"}</span><br />
                      <span> Age Group: {b.ageGroup || "N/A"}</span>
                    </li>
                  ))}
                </ul>
              </div>
            )}

            {/* Dashed Line Divider */}
            <hr style={{ borderTop: "2px dashed #ccc", margin: "15px 0" }} />

            {/* Monthly and Annual Premiums */}
            <p style={{ fontSize: "0.9rem", color: "#000", marginBottom: "5px" }}>
              <strong>Monthly Premium:</strong> GH₵ {monthly.toFixed(2)}
            </p>
            <p style={{ fontSize: "0.9rem", color: "#000", marginBottom: "5px" }}>
              <strong>Annual Premium:</strong> GH₵ {annual.toFixed(2)}
            </p>
          </div>
        </div>
      )}
      <Footer />
    </div>
  );
}

export default InsuranceForm;
